export default __webpack_public_path__ + "static/media/Blade's Deathmask of Malice.18e1dbc4.jpg";